// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"306":"component---cache-caches-gatsby-plugin-offline-app-shell-js","532":"styles","678":"component---src-pages-index-js","774":"framework"}[chunkId] + "-" + {"306":"5e33b1b5575e9017209a","532":"aaf1d44c4e18da5df1e8","678":"ebd2d450505b6d32b9e4","774":"56b84c122452d04a28ea"}[chunkId] + ".js";
};